<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>
      {{ (entityId ? 'Modifica media' : 'Aggiungi media') | translate }}
    </mat-card-title>
    <mat-card-content>
      <form [formGroup]="entityForm">
        <app-media-input (load)="loadMediaHandler($event)"></app-media-input>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-content>
      <mat-card-title>{{ 'Media da caricare' | translate }}</mat-card-title>
      <p>
        {{ 'Lista dei media da caricare per essere utilizzati all\'interno dell\'applicazione' | translate }}
      </p>
      <app-media-to-upload
        [files]="(state$ | async)?.filesToUpload"
        (delete)="deleteSelectHandler($event)"
        (upload)="uploadHandler($event)">
      </app-media-to-upload>
    </mat-card-content>
  </mat-card>
</ui-page-container>
